// src/confluence/folder/types.ts
var ConfluenceFolderAriResourceOwner = "confluence", ConfluenceFolderAriResourceType = "folder";

export {
  ConfluenceFolderAriResourceOwner,
  ConfluenceFolderAriResourceType
};
